module.exports = __webpack_public_path__ + "img/WechatIMG1446.d0289dc0.png";